module.exports = __webpack_public_path__ + "img/musicSeason1.3dfd2a22.png";